import React, { useEffect, useRef, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterSheetInterface,
  TransformInstance,
} from "@dndModels";

// import DandDCharacterUtilities from '../../../utilities/character_utilities';

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";

interface Props {
  character: Character;
}

// const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterAdvantageButton({
  character,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [advantage, setAdvantage] = useState(character.char_interface.advantage);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
  });

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const recalculated = () => {
    setAdvantage(character.char_interface.advantage);
    setReloading(true);
  }
  
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12,
          sm: 6
        }}>
        <ToggleButtonBox 
          name="Advantage"
          value={advantage > 0}
          style={{
            height: "16px",
            fontSize: "10px",
            lineHeight: "1.5",
          }}
          colors={{ backgroundColor: "green", color: "White" }}
          onToggle={() => {
            if (character.advantage > 0) {
              character.advantage = 0;
            } else {
              character.advantage = 1;
            }
            if (character.char_interface instanceof TransformInstance) {
              character.char_interface.advantage = character.advantage;
            }
            character.changed();
            character.subscription_holder.recalculated();
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6
        }}>
        <ToggleButtonBox 
          name="Disadvantage"
          value={advantage < 0}
          style={{
            height: "16px",
            fontSize: "10px",
            lineHeight: "1.5",
          }}
          colors={{ backgroundColor: "red", color: "White" }}
          onToggle={() => {
            if (character.advantage < 0) {
              character.advantage = 0;
            } else {
              character.advantage = -1;
            }
            if (character.char_interface instanceof TransformInstance) {
              character.char_interface.advantage = character.advantage;
            }
            character.changed();
            character.subscription_holder.recalculated();
          }}
        />
      </Grid>
    </Grid>
  );
}
